import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminStateInterface } from './interfaces';
import { StateSliceStatus } from '@ax/constants';
import { InitializeProviderStateSucceededPayloadInterface } from '../provider/interfaces';
import { authSlice } from '../auth';

export const adminInitialStateValue: AdminStateInterface = {
  search: {
    isLoading: false,
    result: [],
  },
  isLoading: false,
  connectedClinician: null,
  selectedClinician: null,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState: adminInitialStateValue,
  extraReducers: (builder) => {
    builder.addCase(authSlice.actions.userSignedOut, () => {
      return adminInitialStateValue;
    });
  },
  reducers: {
    adminClinicianSearchChanged(state, _) {
      return { ...state };
    },
    adminClinicianSearchSucceeded(state, action) {
      return {
        ...state,
        search: {
          isLoading: false,
          result: action.payload.result,
        },
      };
    },
    adminClinicianSearchFailed(state, _) {
      return { ...state };
    },
    adminClinicianSelectedRequested(state, _) {
      return { ...state };
    },
    adminClinicianSelectedSucceeded(state, action) {
      return {
        ...state,
        selectedClinician: action.payload.selectedClinician,
      };
    },
    adminConnectedClinicianLoadRequested(state, _) {
      return {
        ...state,
        isLoading: true,
      };
    },
    adminConnectedClinicianLoadSucceeded: (
      state,
      action: PayloadAction<InitializeProviderStateSucceededPayloadInterface>,
    ) => {
      return {
        ...state,
        isLoading: false,
        connectedClinician: {
          userInfo: {
            name: action.payload.providerSettings.data?.name,
            email: action.payload.providerSettings.data?.email,
            ehrName: action.payload.providerSettings.data?.ehrName,
            specialtyName: action.payload.providerSettings.data?.specialtyName,
            siteName: action.payload.providerSettings.data?.siteName,
            mode: action.payload.providerSettings.data?.mode,
            practiceName: action.payload.providerSettings.data?.practiceName,
            guid: state.selectedClinician?.guid,
            uid: state.selectedClinician?.id,
          },
          userSettings: {
            ...(action.payload.providerSettings.data?.appSettings?.providerResponse?.userSettings ??
              {}),
            inactivityTimeoutInMinutes:
              action.payload.providerSettings.data?.appSettings?.providerResponse?.userSettings
                ?.inactivityTimeoutInMinutes ?? 15,
          },
          status: StateSliceStatus.Initialized,
        },
      };
    },
    adminConnectedClinicianLoadFailed: (
      state,
      action: PayloadAction<{ errors: { error: any; message: string }[] }>,
    ) => {
      return {
        ...state,
        loading: false,
        status: StateSliceStatus.Error,
        errors: action.payload.errors.map((error) => error.message),
      };
    },
  },
});

export const {
  adminClinicianSearchChanged,
  adminClinicianSearchSucceeded,
  adminClinicianSearchFailed,
  adminClinicianSelectedRequested,
  adminClinicianSelectedSucceeded,
  adminConnectedClinicianLoadRequested,
  adminConnectedClinicianLoadSucceeded,
  adminConnectedClinicianLoadFailed,
} = adminSlice.actions;

export default adminSlice.reducer;
